// extracted by mini-css-extract-plugin
export default {"padding":"Login_padding__viHzd"};